import { Text, VFlow } from 'bold-ui'
import { RichTextField } from 'components/form/core/RichTextField/RichTextField'
import { MetaPath } from 'util/metaPath'
import {
  CondutaGroupEnum,
  CUIDADO_COMPARTILHADO_CONDUTAS_PLACEHOLDER,
  DiscussaoCasoSolicitanteFieldsModel,
  PerguntaCuidadoCompartilhadoFieldsModel,
} from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

import { OnCondutaGroupChangeCallback } from '../../discussao-caso/DiscussaoCasoFieldGroup'
import { CondutaGroupCuidadoCompartilhadoRadioFieldContainer } from './CondutaGroupCuidadoCompartilhadoRadioFieldContainer'

interface PerguntaCuidadoCompartilhadoFieldProps {
  path: MetaPath<DiscussaoCasoSolicitanteFieldsModel>
  onCondutaGroupChange: OnCondutaGroupChangeCallback
}

export const PerguntaCuidadoCompartilhadoField = (props: PerguntaCuidadoCompartilhadoFieldProps) => {
  const { path, onCondutaGroupChange } = props
  const name = path[CondutaGroupEnum.NOVA_PERGUNTA]

  return (
    <CondutaGroupCuidadoCompartilhadoRadioFieldContainer<PerguntaCuidadoCompartilhadoFieldsModel>
      name={name}
      pathCondutaGroup={path.condutaGroup}
      value={CondutaGroupEnum.NOVA_PERGUNTA}
      onAskUserConfirmation={onCondutaGroupChange}
    >
      <VFlow>
        <Text>
          Insira uma observação caso ainda existam dúvidas ou questionamentos sobre a discussão de caso do cidadão.
        </Text>
        <RichTextField
          name={name.pergunta}
          label='Observações'
          placeholder={CUIDADO_COMPARTILHADO_CONDUTAS_PLACEHOLDER}
          maxLength={1000}
          required
        />
      </VFlow>
    </CondutaGroupCuidadoCompartilhadoRadioFieldContainer>
  )
}
